//* Libraries imports
import { motion } from 'framer-motion';

//* Schemas imports
import type { FullProcess } from "../../../../schemas/common/process/process";

//* Components imports  
import Icon from "../../../../components/common/Icon";
import { ViewCard } from "../../../../component/common/ViewCard/view-card";
import { Card } from "react-bootstrap";

//* Icons imports
import { MdLock } from 'react-icons/md';


//* Utils imports
import { 
  createCardsFromPermissions,
  type CreateCardsOptions
} from "../../../../utils/processPermissions/featureConfig";

type ViewListCardProps = {
  processId: number;
  faculdadePermissions?: FullProcess['faculdadePermissions'];
  cardOptions?: CreateCardsOptions;
};

export function ViewListCard({ 
  processId, 
  faculdadePermissions, 
  cardOptions 
}: ViewListCardProps) {
  const cards = createCardsFromPermissions(faculdadePermissions, processId, cardOptions);

  if (cards.length === 0) {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8 col-xl-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <Card className="shadow-lg text-center">
                <Card.Body className="p-5">
                  <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ 
                      duration: 0.6, 
                      delay: 0.3,
                      type: "spring",
                      stiffness: 200 
                    }}
                    className="mb-4"
                  >
                    <div className="d-flex justify-content-center align-items-center">
                      <Icon 
                        icon={MdLock} 
                        size={60} 
                        className="text-muted"
                      />
                    </div>
                  </motion.div>

                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: 0.5 }}
                  >
                    <h3 className="text-muted mb-3">Nenhuma Funcionalidade Disponível</h3>
                    <p className="text-muted mb-4 lead">
                      Ainda não há funcionalidades disponíveis para este processo seletivo.
                    </p>
                  </motion.div>
                </Card.Body>
              </Card>
            </motion.div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="row g-4 justify-content-center">
        {cards.map((card, index) => (
          <motion.div
            key={card.id}
            className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <ViewCard
              title={card.title}
              description={card.description}
              icon={card.icon}
              routePath={card.routePath}
              backgroundColor={card.backgroundColor}
              textColor={card.textColor}
              className={card.className}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
